import { handleLogout } from 'v4/lib/auth';

let refreshPromise = null;
let cachedToken = null;
let cachedExp = 0;

const decodeTokenExp = (token) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return 0;
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return (payload.exp || 0) * 1000;
  } catch (e) {
    return 0;
  }
};

const isTokenExpiringSoon = (token, bufferSeconds = 60) => {
  // if (!token) return true;
  if (!token) return false;
  if (token !== cachedToken) {
    cachedToken = token;
    cachedExp = decodeTokenExp(token);
  }
  if (!cachedExp) return false;
  return cachedExp - Date.now() < bufferSeconds * 1000;
};

const getFreshToken = async () => {
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const refreshRes = await fetch('/api/token/refresh', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        });
        const refreshData = await refreshRes.json().catch(() => null);
        if (refreshRes.ok && refreshData?.access) {
          localStorage.setItem('access', refreshData.access);
          cachedToken = refreshData.access;
          cachedExp = decodeTokenExp(refreshData.access);
          return refreshData.access;
        }
        return null;
      } catch (e) {
        return null;
      } finally {
        refreshPromise = null;
      }
    })();
  }
  return refreshPromise;
};

export default async function API({
  url,
  method = 'GET',
  body = '',
  isFormData = false,
  isNoToken = false,
  headers,
  isResponseJSON = true,
  external = false,
  caching = false,
  throwErrorHandler = false, //make it true if need to throw error on api fails
  defaultStatusCode = false,
  _isRetry = false,
}) {
  let options = {
    method,
    headers: {
      Accept: 'application/json',
    },
  };
   // Get user language from localStorage, default to 'en' if not found
  //  const userLanguage = localStorage.getItem('userLanguage') || 'en';
  let userLanguage = 'en';
  if (typeof window !== 'undefined') {
    // We're in the browser
    userLanguage = localStorage.getItem('userLanguage') || 'en';
    if(userLanguage == 'undefined') userLanguage = 'en'
  }
   // Add Accept-Language header with the user's selected language
   options.headers['Accept-Language'] = userLanguage;
  if (!isNoToken) {
    // options.headers['Authorization'] =
    //   'Bearer ' + localStorage.getItem('access');
    let token = typeof window !== 'undefined' ? localStorage.getItem('access') : '';
    if (token && isTokenExpiringSoon(token, 60)) {
      const freshToken = await getFreshToken();
      if (freshToken) {
        token = freshToken;
      }
    }

    // if (!token || isTokenExpiringSoon(token, 0)) {
    //   if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/signin')) {
    //     cachedToken = null;
    //     cachedExp = 0;
    //     handleLogout();
    //     return;
    //   }
    // }

    // options.headers['Authorization'] = 'Bearer ' + token;
    if (token) {
      options.headers['Authorization'] = 'Bearer ' + token;
    }
  }
  if (body) {
    options.body = body;
  }
  if (!isFormData) {
    options.headers['content-type'] = 'application/json; charset=UTF-8';
  }
  if (headers) {
    options.headers['content-type'] =
      'multipart/form-data; boundary=63c5979328c44e2c869349443a94200e';
  }
  if (caching) {
    options.headers['Cache-Control'] =
    "public, max-age=86400";
  }

  const res = await fetch(`${external ? '' : process.env.BASE_API_URL}${url}`, options);

  if (res.status === 401 && !isNoToken) {
    if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/signin')) {
      // cachedToken = null;
      // cachedExp = 0;
      // handleLogout();
      // return;
      const hasToken = !!localStorage.getItem('access');
      if (hasToken) {
        cachedToken = null;
        cachedExp = 0;
        handleLogout();
        return;
      }
    }
  }

  if (!throwErrorHandler) {
    return isResponseJSON ? await res.json() : res;
  }else{
    let data;
    try {
      data = isResponseJSON ? await res.json() : await res.text();
      if (defaultStatusCode) {
        if (typeof data !== 'object' || data === null) {
          data = { data, status_code: res.status };
        } else {
          data.status_code = res.status;
        }
      }
    } catch (err) {
      data = null;
    }

    if (!res.ok) {
      // 🔑 Throw error with status + response body
      const error = new Error(data?.message || res.statusText || 'Request failed');
      error.status = res.status;
      error.data = data;
      throw error;
    }

    return data;
  }  
}
